/* spx-step3-bn.js — builds the buy-column blocks Blue Nile has that we
   didn't: rating, the shipping row above the CTA, the spec tables, and the
   "What to Expect" band.

   2026-07-28 (owner: "not just do an override"): every block is now CREATED at
   its final position in the column instead of being appended and then shuffled
   by a flex `order` ladder in spx-step3-bn.css. That ladder is gone.

   These blocks stay in JS rather than moving into Liquid for one reason: the
   diamond is not a Shopify product on this page. It is fetched after load from
   the _diamonmd cookie / ?diamond= param, so Liquid cannot know its carat,
   shape or certificate at render time. Anything downstream of the stone —
   title, breakdown, spec table — therefore has to be built client-side. The
   parts that DON'T depend on the stone (the What to Expect band) have been
   moved into snippets/sp-step3-what-to-expect.liquid and are real markup.

   Every block is idempotent and re-checked on a short poll, because the theme
   re-renders this column after first paint. Note the distinction that matters:
   we insert-on-create and never relocate, so a re-render restores the right
   sequence rather than fighting it.

   Revert = delete the <link>/<script> pair from sp-final-ring-polish.liquid
   and restore the insertion points in spx-step3-summary-cards.js. */
(function () {
  if (window.__spBnStep3Init) return;
  window.__spBnStep3Init = true;

  var SHIP_ICON =
    '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.4" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M3 7h11v10H3zM14 10h4l3 3v4h-7z"/><circle cx="6.5" cy="18.5" r="1.6"/>' +
    '<circle cx="17.5" cy="18.5" r="1.6"/></svg>';
  var RETURN_ICON =
    '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.4" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M3 10a9 9 0 1 1 2 5.7"/><path d="M3 5v5h5"/></svg>';

  function meta() {
    var s = document.getElementById('finalmainsection');
    return s ? s.querySelector('.product-single__meta') : null;
  }

  /* ── rating, from the reviews metafield (the Judge.me widget is lazy-loaded
        and may never have run this high on the page) ────────────────────── */
  function buildRating() {
    var head = document.querySelector('#finalmainsection .sp-frh');
    if (!head) return false;
    var src = document.querySelector('[data-sp-bn-rating]');
    if (!src) return true;                       /* no metafield: skip quietly */
    var avg = parseFloat(src.getAttribute('data-sp-bn-rating') || '');
    var num = (src.getAttribute('data-sp-bn-count') || '').trim();
    if (isNaN(avg)) return true;
    avg = (Math.round(avg * 10) / 10).toFixed(1);
    var el = head.querySelector('.sp-bn-rating');
    if (!el) {
      el = document.createElement('div');
      el.className = 'sp-bn-rating';
      /* owner 2026-07-30 v3: the share button is gone, so the stars take its
         old spot — right end of the title row, beside the ring name */
      var top = head.querySelector('.sp-frh__toprow');
      var prow = head.querySelector('.sp-frh__prow');
      if (top) top.appendChild(el);
      else if (prow) prow.insertBefore(el, prow.querySelector('.sp-frh__a'));
      else head.insertBefore(el, head.firstChild);
    }
    /* owner 2026-07-30: the stars are a working link to the reviews, not
       decoration — clicking scrolls to the Judge.me widget */
    if (!el.__revWired) {
      el.__revWired = true;
      el.setAttribute('role', 'link');
      el.setAttribute('tabindex', '0');
      el.setAttribute('aria-label', 'Jump to customer reviews');
      var goReviews = function () {
        var rev = document.querySelector('#judgeme_product_reviews, .jdgm-rev-widg');
        if (rev) rev.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };
      el.addEventListener('click', goReviews);
      el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); goReviews(); } });
    }
    /* Blue Nile prints stars then the count in parentheses, no numeral. */
    var html = '<span class="sp-bn-rating__s" aria-hidden="true">★★★★★</span>' +
               (num ? '<span>(' + num + ')</span>' : '<b>' + avg + '</b>');
    if (el.innerHTML !== html) el.innerHTML = html;
    return true;
  }

  /* ── "The total carat weight of your ring is X ct." ─────────────────── */
  function buildCarat() {
    var m = meta();
    if (!m) return false;
    var stone = m.querySelector('.sp-stp-card[data-card=stone] .sp-stp-card__title');
    var txt = stone ? (stone.textContent || '') : '';
    var hit = txt.match(/(\d+(?:\.\d+)?)\s*carat/i);
    if (!hit) return false;
    /* Blue Nile runs rating -> carat -> price, so this sits inside the header
       block just above the price row rather than after it. */
    var head = m.querySelector('.sp-frh');
    var el = m.querySelector('.sp-bn-carat');
    if (!el) {
      el = document.createElement('p');
      el.className = 'sp-bn-carat';
      var prow = head ? head.querySelector('.sp-frh__prow') : null;
      if (prow) head.insertBefore(el, prow);
      else m.appendChild(el);
    }
    var next = 'The total carat weight of your ring is ' + hit[1] + ' ct.';
    if (el.textContent !== next) el.textContent = next;
    return true;
  }

  /* ── shipping links + "Ships by", directly above Add to Cart ────────── */
  function buildShip() {
    var m = meta();
    if (!m) return false;
    var el = m.querySelector('.sp-bn-ship');
    if (!el) {
      el = document.createElement('div');
      el.className = 'sp-bn-ship';
      /* The Free Insured Shipping / 30-Day Returns links used to sit here too.
         Both now have their own rows in the What to Expect band below, so this
         is just the ship-by date — the one piece that earns its place next to
         the Add to Cart button. */
      el.innerHTML = '<span class="sp-bn-ship__by"></span>';
      /* 2026-07-28: sits directly above Add to Cart, which is where Blue Nile
         puts it. Was appendChild + `order: 6`; now it is created in place. */
      var form = m.querySelector(':scope > form[action*="/cart/add"]')
              || m.querySelector(':scope > form');
      if (form) m.insertBefore(el, form); else m.appendChild(el);
    }
    /* mirror the theme's own ship-by date rather than computing a second one */
    var src = document.getElementById('shipByDate');
    var slot = el.querySelector('.sp-bn-ship__by');
    var date = src ? (src.textContent || '').trim() : '';
    var next = date
      ? 'Ships by: <b>' + date + '</b>'
      : 'Ships by: select a ring size for an exact date.';
    if (slot.innerHTML !== next) slot.innerHTML = next;
    return true;
  }

  /* ── "Your Order Includes" ──────────────────────────────────────────── */
  function buildIncludes() {
    var m = meta();
    if (!m) return false;
    if (m.querySelector('.sp-bn-includes')) return true;
    var el = document.createElement('div');
    el.className = 'sp-bn-includes';
    el.innerHTML =
      '<p class="sp-bn-includes__h">Your Order Includes</p>' +
      '<div class="sp-bn-includes__i">' + SHIP_ICON +
        '<div><div class="sp-bn-includes__t">Free insured shipping</div>' +
        '<div class="sp-bn-includes__d">Fully insured and signature required, ' +
        'in a Stienhardt presentation box.</div></div></div>' +
      '<div class="sp-bn-includes__i">' + RETURN_ICON +
        '<div><div class="sp-bn-includes__t">Free 30-day returns</div>' +
        '<div class="sp-bn-includes__d">Our commitment does not end at delivery — ' +
        'returns and resizing are on us.</div></div></div>';
    m.appendChild(el);                            /* position is CSS order:9 */
    return true;
  }


  /* ── inline spec tables under the gallery ────────────────────────────
     Blue Nile lists Diamond Details, Ring Details and side-stone info as
     zebra tables directly beneath the gallery rather than behind accordions.

     Sources, in order of preference:
       diamond  window._spFullDiamond   (complete: cert, polish, symmetry,
                                          depth, table, L/W, measurements, sku)
       fallback .pair-first-diamond p   (meta__title / meta-info-desc pairs)
       ring     "Ring Setting Details"  (<p>Key: Value</p> metafield rich text)
       side     .sp-merged-side-section (same shape)

     Note: the theme renders the certificate links with href="null" when the
     lab URL is missing, so the link is only emitted when a real URL exists. */

  function esc(v){
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function table(title, rows){
    var body = rows.filter(function (r) {
      return r[1] !== undefined && r[1] !== null && String(r[1]).trim() !== '';
    });
    if (!body.length) return '';
    return '<div class="sp-bn-specs">' +
      '<h3 class="sp-bn-specs__h">' + esc(title) + '</h3>' +
      '<table class="sp-bn-specs__t"><tbody>' +
      body.map(function (r) {
        return '<tr><td>' + esc(r[0]) + '</td><td>' + r[1] + '</td></tr>';
      }).join('') +
      '</tbody></table></div>';
  }

  function pairsFrom(root){
    var o = {};
    if (!root) return o;
    root.querySelectorAll('p').forEach(function (p) {
      var t = (p.textContent || '').replace(/\s+/g, ' ').trim();
      var i = t.indexOf(':');
      if (i > 0 && i < 40) o[t.slice(0, i).trim()] = t.slice(i + 1).trim();
    });
    return o;
  }

  function sectionBody(headingRx){
    var s = document.getElementById('finalmainsection');
    if (!s) return null;
    var hit = null;
    s.querySelectorAll('.accordion-header').forEach(function (h) {
      if (headingRx.test((h.textContent || '').trim())) hit = h;
    });
    return hit ? hit.nextElementSibling : null;
  }

  function diamondRows(){
    var d = window._spFullDiamond;
    if (!d) return null;
    var cert = esc(d.cert_num || '');
    if (cert && d.lab_url && d.lab_url !== 'null') {
      cert = '<a href="' + esc(d.lab_url) + '" target="_blank" rel="noopener">' +
             cert + ' &middot; View Report</a>';
    }
    return [
      ['Lab', esc(d.lab)],
      ['Certificate Number', cert],
      ['Stock Number', esc(d.sku)],
      ['Shape', esc(d.shape)],
      ['Cut', esc(d.cut)],
      ['Color', esc(d.color)],
      ['Clarity', esc(d.clarity)],
      ['Carat Weight', esc(d.carat)],
      ['Polish', esc(d.polish)],
      ['Symmetry', esc(d.symmetry)],
      ['Fluorescence', esc(d.fluorescence)],
      ['Table %', d.table ? esc(d.table) + '%' : ''],
      ['Depth %', d.depth ? esc(d.depth) + '%' : ''],
      ['Length/Width Ratio', esc(d.lw_ratio)],
      ['Culet', esc(d.culet)],
      ['Measurements', d.measurement ? esc(d.measurement) + ' mm' : '']
    ];
  }

  function diamondRowsFallback(){
    var wrap = document.querySelector('#finalmainsection .pair-first-diamond');
    if (!wrap) return [];
    var rows = [];
    wrap.querySelectorAll('p').forEach(function (p) {
      var k = p.querySelector('.meta__title');
      var v = p.querySelector('.meta-info-desc');
      if (!k || !v) return;
      var label = (k.textContent || '').trim();
      label = label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();
      rows.push([label, esc((v.textContent || '').trim())]);
    });
    return rows;
  }

  function buildSpecs(){
    /* 2026-07-28: these were parked under the gallery, mirroring Blue Nile.
       That works for them because their gallery is 10 tiles and their right
       column carries three extra panels, so the two columns end together.
       Ours has 7 tiles and a shorter column, which left ~1,850px of dead white
       on the right and stranded the tables in a mid-page band. Moving them
       into the buy column fills that void and squares the page up. */
    var group = document.querySelector('#finalmainsection .product-single__meta');
    if (!group) return false;

    var dRows = diamondRows() || diamondRowsFallback();
    if (!dRows.length) return false;

    var ringP = pairsFrom(sectionBody(/ring setting details/i));
    var metal = (document.querySelector('#finalmainsection .ring-metal') || {}).textContent || '';
    metal = metal.split('/')[0].trim();
    var rRows = [
      ['Metal', esc(metal)],
      ['Setting SKU', esc(ringP['SKU'])],
      ['Average Band Width', esc(ringP['Average Band Width'])],
      ['Average Band Thickness', esc(ringP['Average Band Thickness'])],
      ['Stackable', esc(ringP['Stackable'])]
    ];

    var sideRoot = document.querySelector('#finalmainsection .sp-merged-side-section');
    var sideP = pairsFrom(sideRoot);
    var sRows = Object.keys(sideP).map(function (k) { return [k, esc(sideP[k])]; });

    var html = table('Diamond Details', dRows) +
               table('Ring Details', rRows) +
               table('Side Stone Details', sRows);
    if (!html) return false;

    /* Recomputed every tick rather than built once: the side-stone section
       renders after first paint, and a one-shot build produced the diamond
       and ring tables but silently dropped it (observed 2026-07-28). */
    /* One collapsed "Ring Details" holding all three tables, rather than three
       always-open blocks. <details> so the open/closed state needs no JS.

       The <details> element is created ONCE and never replaced; only its body
       is re-rendered. An earlier version rebuilt the whole shell whenever the
       serialized HTML differed — but opening it adds open="" to that HTML, so
       it no longer matched the template and the element was destroyed and
       recreated on every 250ms tick, snapping shut as fast as you could open
       it. Never diff innerHTML against a template on a stateful element. */
    var wrap = group.querySelector(':scope > .sp-bn-specwrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'sp-bn-specwrap';
      /* 2026-07-28: directly after the breakdown cards and BEFORE the detail
         accordions, which are the last thing in the column in the template's
         own markup. Was appendChild + `order: 10` beating the accordions'
         `order: 20`; now the DOM says it outright. */
      var cards = group.querySelector(':scope > .sp-stp-cards');
      if (cards) {
        group.insertBefore(wrap, cards.nextSibling);
      } else {
        var acc = group.querySelector(
          ':scope > .product_description--accordion:not(.product-engraving-wrapper)');
        if (acc) group.insertBefore(wrap, acc); else group.appendChild(wrap);
      }
    }
    var det = wrap.querySelector(':scope > .sp-bn-det');
    if (!det) {
      det = document.createElement('details');
      det.className = 'sp-bn-det';
      var sum = document.createElement('summary');
      sum.className = 'sp-bn-det__sum';
      sum.textContent = 'Ring Details';
      var bodyEl = document.createElement('div');
      bodyEl.className = 'sp-bn-det__body';
      det.appendChild(sum);
      det.appendChild(bodyEl);
      wrap.appendChild(det);
    }
    var detBody = det.querySelector(':scope > .sp-bn-det__body');
    if (detBody && detBody.innerHTML !== html) detBody.innerHTML = html;

    /* the three accordions these tables replace */
    /* About Your Ring dropped 2026-07-28 (owner): it restated the title and
       the spec rows. */
    [/ring setting details/i, /side stone details/i, /^diamond details$/i,
     /about your ring/i].forEach(function (rx) {
      var s = document.getElementById('finalmainsection');
      s.querySelectorAll('.accordion-header').forEach(function (h) {
        if (!rx.test((h.textContent || '').trim())) return;
        h.setAttribute('data-sp-bn-replaced', 'true');
        if (h.nextElementSibling) h.nextElementSibling.setAttribute('data-sp-bn-replaced', 'true');
      });
    });
    return true;
  }


  /* ── even out the gallery ────────────────────────────────────────────
     The media grid is 2-up. With an odd number of visible tiles the last one
     sits alone with a hole beside it. Widen that one to fill the row.
     Counts VISIBLE tiles rather than children, because the group carries a
     zero-size placeholder that would throw an :nth-child(odd) rule off. */
  function evenGallery(){
    var g = document.querySelector('#finalmainsection .product-single__media-group');
    if (!g) return false;
    var vis = Array.prototype.filter.call(g.children, function (el) {
      if (el.classList.contains('sp-bn-specwrap')) return false;
      return el.getBoundingClientRect().width > 1;
    });
    if (!vis.length) return false;
    var last = vis[vis.length - 1];
    var wants = (vis.length % 2) === 1;
    Array.prototype.forEach.call(g.children, function (el) {
      if (el !== last) el.classList.remove('sp-bn-lastwide');
    });
    /* 2026-07-28 (owner): widening the odd last tile blew the 360 viewer up
       to full width. Leave every tile at grid size; an occasional gap on
       the last row is preferable to a giant spinning stone. */
    last.classList.remove('sp-bn-lastwide');
    void wants;
    return true;
  }


  /* ── title: identical to the cart's combined-ring title ──────────────
     sections/main-cart.liquid:313-336 builds the cart line as

       swc_name = setting.product.title | replace: ' Setting', ''
       "{carat} Carat {shape} on the {swc_name} Engagement Ring"

     so the shopper sees the same name on step 3 and in the cart. The theme's
     own step-3 header shipped a generic "Your Bespoke Engagement Ring", which
     matched nothing and was only 38px tall — one line where Blue Nile's is
     three — which pulled ring size and engraving up the column with it. */
  function buildTitle(){
    var t = document.querySelector('#finalmainsection .sp-frh__t');
    if (!t) return false;
    var setEl = document.querySelector(
      '#finalmainsection .sp-stp-card[data-card=setting] .sp-stp-card__title');
    if (!setEl) return false;
    var name = (setEl.textContent || '').trim().replace(/\s*Setting\s*$/i, '');
    if (!name) return false;

    var d = window._spFullDiamond || {};
    var carat = (d.carat || '').toString().trim();
    var shape = (d.shape || '').toString().trim();
    if (!carat || !shape) {
      /* fall back to the stone card, same as the cart falls back to the
         diamond product title when the Carat property is absent */
      var stone = document.querySelector(
        '#finalmainsection .sp-stp-card[data-card=stone] .sp-stp-card__title');
      var txt = stone ? (stone.textContent || '') : '';
      var m = txt.match(/([\d.]+)\s*Carat\s+([A-Za-z ]+?)\s+(?:Lab|Natural|IGI|GIA)/i);
      if (m) { carat = carat || m[1]; shape = shape || m[2].trim(); }
    }

    /* 2026-07-30 v2: the header is now split (spx-final-ring-header.js) —
       small eyebrow with carat + shape above a SHORT H1 (setting name), so
       the name stays large AND on one line. Update both parts; never blank
       the eyebrow while diamond data is still pending. The CART keeps the
       combined "{carat} Carat {shape} on the {name}" string — only this
       header uses the split. */
    var next = name + ' Engagement Ring';
    if (t.textContent.trim() !== next) t.textContent = next;
    if (carat && shape) {
      var eb = document.querySelector('#finalmainsection [data-frh-eyebrow]');
      if (eb) {
        var ebNext = carat + ' Carat ' + shape + ' Lab Grown Diamond';
        if (eb.textContent.trim() !== ebNext) { eb.textContent = ebNext; eb.hidden = false; }
      }
    }
    return true;
  }


  /* ── kill empty accordion shells ─────────────────────────────────────
     A .product_description--accordion with no content still paints its top and
     bottom border, which showed up as two hairlines 6px apart below the Ring
     Details block. */
  function hideEmptyAccordions(){
    var s = document.getElementById('finalmainsection');
    if (!s) return false;
    s.querySelectorAll('.product_description--accordion').forEach(function (a) {
      if (a.classList.contains('product-engraving-wrapper')) return;
      if (a.getAttribute('data-sp-bn-replaced') === 'true') return;
      /* The container wrapping every accordion still paints its own top and
         bottom border once all its headers are hidden — that was the pair of
         hairlines 6px apart under Ring Details. Hide the shell too. */
      var heads = a.querySelectorAll('.accordion-header');
      var allHidden = heads.length > 0 && Array.prototype.every.call(heads, function (h) {
        return h.getAttribute('data-sp-bn-replaced') === 'true';
      });
      var txt = (a.textContent || '').replace(/\s+/g, '').trim();
      if (!txt || allHidden) a.setAttribute('data-sp-bn-replaced', 'true');
    });
    return true;
  }


  /* ── "What to Expect" ────────────────────────────────────────────────
     The band's markup, copy, icons and photo now live in
     snippets/sp-step3-what-to-expect.liquid. WTE_IMAGE, WTE_ICON and wteRow()
     were deleted with it (2026-07-28) — change the photo in the snippet.

     Label follows the grading lab on the stone. The full name goes in the
     sub-line so the acronym isn't doing all the work. */
  var LAB_NAMES = {
    IGI:  'International Gemological Institute',
    GIA:  'Gemological Institute of America',
    GCAL: 'Gem Certification & Assurance Lab'
  };

  /* 2026-07-28: the band itself is now snippets/sp-step3-what-to-expect.liquid,
     rendered by product-final-template.liquid. Only the two stone-dependent
     values are still filled here — the ship-by date and the grading lab. The
     copy, the icons and the presentation-box photo are static markup and no
     longer wait on JavaScript.

     Returns true when the snippet is absent so the poll doesn't spin on a page
     that legitimately doesn't render it. */
  function fillWte(){
    var el = document.querySelector('.sp-wte');
    if (!el) return true;

    /* (2026-09-24) Estimated Delivery = #deliveryByDate (ship date + transit, the
       cart's rule) - it used to show the ship date. International visitors get the
       dispatch date (data-intl="1"), so the label says so. */
    var src  = document.getElementById('deliveryByDate');
    var slot = el.querySelector('[data-wte-date]');
    if (slot) {
      var date = src ? (src.textContent || '').trim() : '';
      if (slot.textContent !== date) slot.textContent = date;
      var dlab = slot.previousElementSibling;
      var dlabText = (src && src.getAttribute('data-intl') === '1') ? 'Estimated Ship Date' : 'Estimated Delivery';
      if (dlab && dlab.classList.contains('sp-wte__label') && dlab.textContent !== dlabText) dlab.textContent = dlabText;
    }

    var row = el.querySelector('[data-wte-cert]');
    if (row) {
      var d = window._spFullDiamond || {};
      var lab = String(d.lab || '').trim().toUpperCase();
      if (lab) {
        var lbl = row.querySelector('[data-wte-cert-label]');
        var sub = row.querySelector('[data-wte-cert-sub]');
        var lblText = lab + ' Certificate';
        var subText = LAB_NAMES[lab]
          ? 'Independently graded by the ' + LAB_NAMES[lab]
          : 'Independently graded and supplied with your ring';
        if (lbl && lbl.textContent !== lblText) lbl.textContent = lblText;
        if (sub && sub.textContent !== subText) sub.textContent = subText;
        if (row.hasAttribute('hidden')) row.removeAttribute('hidden');
      } else if (!row.hasAttribute('hidden')) {
        row.setAttribute('hidden', '');
      }
    }
    return true;
  }

  function apply() {
    var on = !!document.getElementById('finalmainsection');
    document.body.classList.toggle('sp-bn-step3', on);
    if (!on) return false;
    buildTitle();
    buildRating();
    /* carat-weight line dropped 2026-07-28 (owner): the carat is already in
       the title and the diamond row, so it was a third repeat. */
    buildShip();
    /* buildIncludes() retired 2026-07-28 — the What to Expect band below
       the product grid says the same thing with more room. */
    fillWte();
    buildSpecs();
    evenGallery();
    hideEmptyAccordions();
    return true;
  }

  function boot() {
    apply();
    var n = 0;
    var iv = setInterval(function () { apply(); if (++n > 60) clearInterval(iv); }, 250);
    /* (2026-09-24) refill What to Expect whenever the delivery date lands - also
       after the poll above has stopped (slow diamond API) */
    var dd = document.getElementById('deliveryByDate');
    if (dd && window.MutationObserver) {
      new MutationObserver(function () { fillWte(); })
        .observe(dd, { childList: true, characterData: true, subtree: true, attributes: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
